import React from 'react';
import SpaceBackground from './components/SpaceBackground';
import { BrowserRouter as Router, createRoutesFromChildren, Navigate, Route } from 'react-router-dom';
import Home from './pages/Home';
import FanArt from './pages/FanArt';
import Bible from './pages/Bible';
import Blog from './pages/Blog';
import Article from './pages/Article';
import Wiki from './pages/Wiki';
import Actor from './pages/Actor';
import English from './pages/English';
import Sermon from './pages/Sermon';
import Caption from './pages/Caption';
import Manga from './pages/Manga';
import MangaList from './pages/MangaList';
import Pay from './pages/Pay';
import ListComponent from './components/ListComponent';
import WikiComponent from './components/WikiComponent';
import Characters from './pages/Characters';
import Seiroku from './pages/Seiroku';
import Qa from './pages/qa';
import Privacy from './pages/Privacy';
import Support from './pages/Support';
import Admin from './pages/Admin';
import PasswordReset from './pages/PasswordReset';
import Contact from './pages/Contact';
import Jobs from './pages/Jobs';
import JobVoiceActor from './pages/JobVoiceActor';
import VoiceCounter from './pages/VoiceCounter';
import JobEzekiel from './pages/JobEzekiel';
import KirikanGuideline from './pages/KirikanGuideline';
import AnalyticsTracker from './components/AnalyticsTracker';
import GoogleTag from './components/GoogleTag';
import FloatingTools from './components/FloatingTools';
import BibleSelectionSound from './components/BibleSelectionSound';
import InternalNavigation from './components/InternalNavigation';
import PageTransition from './components/PageTransition';
import IosAppBanner from './components/IosAppBanner';

const appRoutes = (
  <>
    <Route path="/" element={<Home />} />
    <Route path="/fanart" element={<FanArt />} />
    <Route path="/bible/:section/:chapter/:verse" element={<Bible />} />
    <Route path="/bible/:section" element={<Bible />} />
    <Route path="/blog" element={<ListComponent type="blog" title={`ブログ`}/>} />
    <Route path="/blog/:id" element={<Blog />} />
    <Route path="/journal" element={<Navigate to="/" replace />} />
    <Route path="/journal/:id" element={<Navigate to="/" replace />} />
    <Route path="/actor/:id" element={<Actor />} />
    <Route path="/actor" element={<ListComponent type="actor" title={`声優図鑑`}/>} />
    <Route path="/wiki/:id" element={<Wiki />} />
    <Route path="/wiki" element={<WikiComponent type="wiki" title={`聖書ASMRウィキ`}/>} />
    <Route path="/english/:id" element={<English />} />
    <Route path="/english" element={<ListComponent type="english" title={`英語講座`}/>} />

    <Route path="/article/:id" element={<Article />} />
    <Route path="/article" element={<ListComponent type="article" title={`記事`}/>} />
    <Route path="/sermon/:id" element={<Sermon />} />
    <Route path="/manga/:id" element={<Manga />} />
    <Route path="/manga" element={<MangaList />} />
    <Route path="/characters" element={<Characters />} />
    <Route path="/qa" element={<Qa />} />
    <Route path="/seiroku" element={<Seiroku />} />
    <Route path="/sermon" element={<ListComponent type="sermon" title={`説教`}/>} />
    <Route path="/caption" element={<Caption />} />
    <Route path="/pay" element={<Pay />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/kirikan-guideline" element={<KirikanGuideline />} />
    <Route path="/support" element={<Support />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/jobs" element={<Jobs />} />
    <Route path="/jobs/voice-actor" element={<JobVoiceActor />} />
    <Route path="/jobs/voice-counter" element={<VoiceCounter />} />
    <Route path="/jobs/ezekiel/:chapter" element={<JobEzekiel />} />
    <Route path="/jobs/sermon/:chapter" element={<JobEzekiel />} />
    <Route path="/admin" element={<Admin />} />
    <Route path="/password-reset" element={<PasswordReset />} />
  </>
);
const navigationRoutes = createRoutesFromChildren(appRoutes);

function App() {
  return (
    <Router>
      <GoogleTag />
      <IosAppBanner />
      <SpaceBackground />
      <InternalNavigation routes={navigationRoutes} />
      <AnalyticsTracker />
      <FloatingTools />
      <BibleSelectionSound />
      <PageTransition>{appRoutes}</PageTransition>
    </Router>
  );
}

export default App;
